import React from "react";
import SeoHelmet, { faqSchema, breadcrumbSchema } from "../components/SeoHelmet";
import Faq from "../components/Faq";
import { ALL_FAQS } from "../data/faqs";
import { Link } from "react-router-dom";

export default function FaqPage() {
    return (
        <>
            <SeoHelmet
                title="FAQ — Frequently Asked Questions about CSV"
                description="Common questions about CSV files, our editor, pricing, privacy, and more — answered in plain English."
                schema={[
                    breadcrumbSchema([{ label: "Home", href: "/" }, { label: "FAQ", href: "/faq" }]),
                    faqSchema(ALL_FAQS),
                ]}
            />
            <header className="border-b border-black/10">
                <div className="mx-auto max-w-4xl px-4 md:px-8 py-12">
                    <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted">/ help</div>
                    <h1 className="font-display font-black tracking-tighter text-5xl md:text-6xl mt-3">FAQ</h1>
                    <p className="mt-5 text-ink-soft max-w-2xl">Everything we get asked about CSV files, OpenCSV, pricing, privacy, and how the app works. Still stuck? <Link to="/about" className="underline text-cobalt hover:text-cobalt-hover">Reach Fitz directly</Link>.</p>
                </div>
            </header>
            <Faq items={ALL_FAQS} title="Common questions" />
        </>
    );
}
